import React, { useEffect } from "react";

import ContactMangementSection from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ClientInfoV2/ContactManagementSection";
import Navigation from "../../../../../components/navigations/client/detail/client-info/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/client-info/contact");
  }, []);

  return (
    <Navigation activeTab="contact" _case={_case}>
      <ContactMangementSection caseObj={_case} />
    </Navigation>
  );
};
